import getChartColorsArray from '../../../../Common/ChartsDynamicColor';
import React from 'react';
import ReactApexChart from 'react-apexcharts';
import {mockProducts} from "../../../../data/products";


const Basicchart = ({ dataColors }:any) => {
    const BasicColors = getChartColorsArray(dataColors);
    const generateRandomSeries = (length:any, min = 300, max = 1400) => {
        return Array.from({ length }, () => Math.floor(Math.random() * (max - min + 1)) + min);
    };

    const series = [{
        data: generateRandomSeries(mockProducts.length)
    }];

    const options:any = {
        chart: {
            height: 350,
            type: 'bar',
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
            }
        },
        dataLabels: {
            enabled: false,
        },
        colors: BasicColors,
        grid: {
            borderColor: "#f1f1f1",
            padding: {
                bottom: -14,
                left: 0,
                right: 0
            }
        },
        xaxis: {
            categories: mockProducts.map((product:any) => (product.name)),
        }
    };

    return (
        <React.Fragment>
           <ReactApexChart
                dir='ltr'
                className="apex-charts"
                options={options}
                series={series}
                type="bar"
                height="350px"
            />
        </React.Fragment>
    );
};

export default Basicchart;